
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Foodchain.css";

// imports for images...
import biryani2 from "../../assets/biryani2.jpg";
import butter1 from "../../assets/butter1.jpg";
import samosa2 from "../../assets/samosa2.jpg";
import chole2 from "../../assets/chole2.jpg";
import cold1 from "../../assets/cold1.jpg";
import rajma1 from "../../assets/rajma1.jpg";
import dhokla1 from "../../assets/dhokla1.jpg";
import vada2 from "../../assets/vada2.jpg";
import idli2 from "../../assets/idli2.jpg";
import momos2 from "../../assets/momos2.jpg";
import fish1 from "../../assets/fish1.jpg";
import gulab1 from "../../assets/gulab1.jpg";
import coco from "../../assets/coco.jpg";
import mango1 from "../../assets/mango1.jpg";

const imgSlider = [
  { name: "Butter Chicken", image: butter1 },
  { name: "Samosa", image: samosa2 },
  { name: "Chole Bhature", image: chole2 },
  { name: "Biryani", image: biryani2 },
  { name: "Rajma Chawal", image: rajma1 },
  { name: "Dhokla", image: dhokla1 },
  { name: "Vada Pav", image: vada2 },
  { name: "Idli", image: idli2 },
  { name: "Momos", image: momos2 },
  { name: "Fish Curry", image: fish1 },
  { name: "Gulab Jamun", image: gulab1 },
  { name: "Coconut Water", image: coco },
  { name: "Cold Coffee", image: cold1 },
  { name: "Mango Ice Cream", image: mango1 },
];

const Foodchain = () => {
  const settings = {
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="main-box">
      <Slider {...settings}>
        {imgSlider.map((item, index) => (
          <div key={index} className="card">
            <img src={item.image} alt={item.name} className="slider-img" />
            <h4 className="food-name">{item.name}</h4>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Foodchain;
